import { twMerge } from '@shared/themes';
import { LastPlayedSvg } from './LastPlayedSvg';

type LastPlayedBackgroundProps = {
  position: number;
  className?: string;
  'data-testid'?: string;
};

const fillClassByPosition: Record<number, string> = {
  0: '[&_path]:fill-eurodreams',
  1: '[&_path]:fill-megadavirada',
  2: '[&_path]:fill-accent-orange',
  3: '[&_path]:fill-accent-green',
  4: '[&_path]:fill-elgordodeverano',
  5: '[&_path]:fill-malamaaldaily',
  6: '[&_path]:fill-cash4life',
  7: '[&_path]:fill-germankeno',
  8: '[&_path]:fill-accent-pink',
  9: '[&_path]:fill-quina',
  10: '[&_path]:fill-6aus49go-special',
  11: '[&_path]:fill-elnino',
  12: '[&_path]:fill-accent-purple',
  13: '[&_path]:fill-accent-neonblue',
  14: '[&_path]:fill-accent-blue',
};

function resolveFillClass(position: number) {
  const index = position > 14 ? 0 : position;
  return fillClassByPosition[index] ?? fillClassByPosition[0]!;
}

function LastPlayedBackground(props: LastPlayedBackgroundProps) {
  const { position = 0, className, ...rest } = props;

  return <LastPlayedSvg className={twMerge('size-full', resolveFillClass(position), className)} {...rest} />;
}

export { LastPlayedBackground, type LastPlayedBackgroundProps };
